import { render, staticRenderFns } from "./BaseButtonWithIconAndText.vue?vue&type=template&id=7dd6a9a8"
import script from "./BaseButtonWithIconAndText.vue?vue&type=script&lang=js"
export * from "./BaseButtonWithIconAndText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports